import React from 'react'
import { FormattedMessage } from 'react-intl';

export const TRACKING_PLATFORMS = {
  FACEBOOK: {
    value: "FACEBOOK",
    label: <FormattedMessage id="fields.campaignManagement.social.facebook" />,
  },
};

export const TRACKING_OPTIONS_PLATFORMS = [
  {
    value: "FACEBOOK",
    label: <FormattedMessage id="fields.campaignManagement.social.facebook" />,
  },
];

// DiscountTypes
export const PERCENT = 0;
export const FIXED = 1;

export const DISCOUNT_TYPE = [
  {
    value: PERCENT,
    label: <FormattedMessage id="fields.campaignManagement.percent" />,
  },
];

export const COUPON_SHARED = 0;
export const COUPON_INDIVIDUAL = 1;

export const COUPON_TYPE = [
  { value: COUPON_SHARED, label: <FormattedMessage id="fields.campaignManagement.shared" /> },
  { value: COUPON_INDIVIDUAL, label: <FormattedMessage id="fields.campaignManagement.individual" /> },
];

export const getCouponLabel = (couponValue) => {
  let label = <FormattedMessage id="components.pages.campaignManagement.unknown" />;

  COUPON_TYPE.forEach(item => {
    if (item.value === couponValue) {
      label = item.label;
    }
  });

  return label;
}
